import { Plugin } from '@ckeditor/ckeditor5-core'
import { ViewModel, addListToDropdown, createDropdown } from '@ckeditor/ckeditor5-ui'
import { Collection } from '@ckeditor/ckeditor5-utils'
import './templates.css'

export default class TemplatesUI extends Plugin {
    init() {
        const editor = this.editor
        const templates = editor.config.get('templatesConfig.types');

        editor.ui.componentFactory.add('templates', locale => {
            const dropdownView = createDropdown(locale)

            dropdownView.class = 'custom-templates-dropdown'

            addListToDropdown(dropdownView, getDropDownItemsDefinitions(templates))

            dropdownView.buttonView.set({
                label: trans('settings.templates'),
                tooltip: `${trans('settings.templates')} (+)`,
                withText: true,
            })

            const command = editor.commands.get('insertTemplates')
            dropdownView.bind('isEnabled').to(command)
            
            // Update tooltip based on command state (enabled or disabled)
            const updateTooltip = () => {
                const tooltipText = command.isEnabled 
                    ? `${trans('settings.templates')} (+)`
                    : `${trans('client.journal_template_tip_1')} ${trans('client.journal_template_tip_2').replace('&rarr;', '→')}`;
                dropdownView.buttonView.set('tooltip', tooltipText);
            };
            
            command.on('change:isEnabled', updateTooltip);
            
            // Set initial tooltip (enabled or disabled)
            updateTooltip();

            this.listenTo(dropdownView, 'execute', evt => {
                editor.execute('insertTemplates', { value: evt.source.commandParam })
                editor.editing.view.focus()
            })

            return dropdownView
        })
    }

}

function getDropDownItemsDefinitions(templates) {
    const itemDefinitions = new Collection()

    if (!templates || templates.length === 0) {
        return itemDefinitions
    }

    for (const template of templates) {
        const label = template.keyword 
            ? `${template.title} [${template.keyword}]`
            : template.title;
            
        const definition = {
            type: 'button',
            model: new ViewModel({
                commandParam: template,
                label: label,
                withText: true,
            })
        }

        itemDefinitions.add(definition)
    }

    return itemDefinitions
} 